import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/ui/Button'

type UnavailableStateProps = {
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
  actionDisabled?: boolean
  /** Escape route to keep alongside a forward action (e.g. "next level"). */
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
  className?: string
}

export function UnavailableState({
  title,
  description,
  actionLabel = 'Voltar',
  onAction,
  actionDisabled = false,
  secondaryActionLabel,
  onSecondaryAction,
  className
}: UnavailableStateProps) {
  return (
    <div
      className={cn(
        'flex min-h-[60vh] w-full items-center justify-center px-4',
        className
      )}
    >
      <div className="w-full max-w-lg rounded-3xl bg-white p-6 text-center shadow-lg">
        <h1 className="text-xl font-bold text-primary-dark">{title}</h1>
        <p className="mt-3 text-sm font-medium text-gray-500">{description}</p>
        {onAction || onSecondaryAction ? (
          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            {onAction ? (
              <Button
                type="button"
                variant="primary"
                className="w-full sm:w-auto"
                onClick={onAction}
                disabled={actionDisabled}
              >
                {actionLabel}
              </Button>
            ) : null}
            {onSecondaryAction && secondaryActionLabel ? (
              <Button
                type="button"
                variant="secondary"
                className="w-full sm:w-auto"
                onClick={onSecondaryAction}
              >
                {secondaryActionLabel}
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}
